/**
 * Resolve the parent expander name for v2 ElementEditor field grouping.
 * Saved email layouts often store categoryGroup but not newCategory.
 */
function resolveParentCategoryName(option) {
    if (option.categoryGroupTitleHidden) return ''
    if (option.newCategory) return option.newCategory
    if (option.editableTab === 'Columns' && option.categoryGroup) return option.categoryGroup
    return 'General'
}

// Category names are stored in English because they double as identifiers for
// remembering which expanders the user left open. Only the visible label goes
// through here. Anything not listed is shown as-is.
const CATEGORY_TRANSLATION_KEYS = {
    Background: 'templates:add.drag.categories.Background',
    Alignment: 'templates:add.drag.categories.Alignment'
}

/**
 * Turn a stored category name into the text shown on its expander.
 * "Column 2" and friends are translated with the number kept separate, so the
 * wording can change per language without hard-coding every number.
 */
function translateCategoryName(name, translate) {
    if (!name || typeof translate !== 'function') return name
    const columnMatch = /^Column (\d+)$/.exec(name)
    if (columnMatch) {
        return translate('templates:add.drag.categories.column', { number: columnMatch[1] })
    }
    const key = CATEGORY_TRANSLATION_KEYS[name]
    return key ? translate(key) : name
}

module.exports = {
    resolveParentCategoryName,
    translateCategoryName
}
